import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PeopleIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PeopleIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12 22C6.48585 22 2 17.5141 2 12C2 6.48586 6.48585 2 12 2C17.5141 2 22 6.48585 22 12C22 17.5141 17.5141 22 12 22ZM12 3.00956C7.04289 3.00956 3.00956 7.04289 3.00956 12C3.00956 16.9571 7.04289 20.9904 12 20.9904C16.9571 20.9904 20.9904 16.9571 20.9904 12C20.9904 7.0429 16.9571 3.00956 12 3.00956Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.3668 20.2801C17.0877 20.2801 16.862 20.0543 16.862 19.7753V19.2281C16.862 17.3042 15.2969 15.7385 13.3729 15.7385H10.6271C8.70315 15.7385 7.13803 17.3042 7.13803 19.2281V19.7753C7.13803 20.0543 6.91226 20.2801 6.63325 20.2801C6.35424 20.2801 6.12847 20.0543 6.12847 19.7753V19.2281C6.12847 16.7471 8.1466 14.729 10.6271 14.729H13.3729C15.8534 14.729 17.8715 16.7471 17.8715 19.2281V19.7753C17.8715 20.0543 17.6458 20.2801 17.3668 20.2801Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12 13.0554C10.1564 13.0554 8.65681 11.5559 8.65681 9.71222C8.65681 7.86859 10.1564 6.36904 12 6.36904C13.8436 6.36904 15.3432 7.86859 15.3432 9.71222C15.3432 11.5559 13.8436 13.0554 12 13.0554ZM12 7.37859C10.7134 7.37859 9.66637 8.42562 9.66637 9.71221C9.66637 10.9988 10.7134 12.0458 12 12.0458C13.2866 12.0458 14.3336 10.9988 14.3336 9.71221C14.3336 8.42562 13.2866 7.37859 12 7.37859Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PeopleIcon;
